import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

interface PasswordChangeData {
  currentPassword: string;
  newPassword: string;
}

interface PasswordChangeResponse {
  success: boolean;
  message?: string;
}


export async function changePassword(
  data: PasswordChangeData
): Promise<PasswordChangeResponse> {
  try {
    const response = await axiosInstance.post<PasswordChangeResponse>(
      `${config.apiUrl}/auth/change-password`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(errorMessage);
    }
    throw new Error("An unexpected error occurred");
  }
}
